module.exports = "https://web-assets-production.autolist.com/_next/static/images/trending-trucks-42077cd2a272e5760bb7d2d28b360b21.jpg";